import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/lib/function';
import * as O from 'fp-ts/Option';
import { toString } from 'lodash';
import * as R from 'ramda';

import { UNASSIGNED } from '@components/DragAndDropContainers/constants/groupnames';
import { Group, Item } from '@components/DragAndDropContainers/types';

import { byContent } from '../helpers';

import {
  ClubStatus,
  ClubType,
  DistrictClub,
  FetchAllDistrictClubsQuery,
} from './types';

export const normalizeUnassignedClub = (
  districtClubsData?: FetchAllDistrictClubsQuery
): Group => {
  const groupId = `groupId-${UNASSIGNED}`;
  const groupName = UNASSIGNED;

  return pipe(
    districtClubsData,
    O.fromNullable,
    O.mapNullable(R.prop('Clubs')),
    O.toNullable,
    item => item || [],
    A.filter(
      ({ status, clubType }) =>
        !R.equals(status, ClubStatus.Terminated) &&
        R.equals(toString(clubType), ClubType.RotaryClub)
    ),

    A.map(({ id, clubName }: DistrictClub) => ({
      id,
      content: clubName,
      data: '',
    })),
    A.sortBy([byContent]),
    (items: Item[]) => ({
      groupId,
      groupName,
      items,
    })
  );
};
